/**
 * Campanhas promocionais programadas — Destino Resorts.
 *
 * Tudo no fuso de Brasília (America/Sao_Paulo), independente do fuso do
 * visitante. As etapas ligam, trocam de texto e encerram sozinhas.
 *
 * Para uma futura campanha: cadastre um novo objeto em CAMPAIGNS com suas
 * fases (start/end + textos). Nenhuma outra alteração é necessária.
 */

export const CAMPAIGNS = [
    {
        id: "black-friday-2026",
        dates_label: "26 a 29 de novembro",
        phases: [
            {
                key: "antecipacao",
                start: "2026-01-01T00:00:00",
                end: "2026-11-25T23:59:59",
                title: "BLACK FRIDAY DESTINO RESORTS",
                subtitle: "Sua próxima experiência inesquecível começa aqui. Antecipe-se!",
                cta: "QUERO ME ANTECIPAR",
            },
            {
                key: "black-friday",
                start: "2026-11-26T00:00:00",
                end: "2026-11-29T23:59:59",
                title: "BLACK FRIDAY DESTINO RESORTS — É AGORA!",
                subtitle: "Chegou o momento de planejar sua próxima experiência!",
                cta: "QUERO MINHA COTAÇÃO",
            },
        ],
    },
];

const TIMEZONE = "America/Sao_Paulo";

/** Data/hora atual convertida para o horário de Brasília ("hora de parede"). */
export function nowInBrasilia(now = new Date()) {
    const parts = {};
    for (const p of new Intl.DateTimeFormat("en-CA", {
        timeZone: TIMEZONE,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
    }).formatToParts(now)) {
        if (p.type !== "literal") parts[p.type] = p.value;
    }
    return new Date(`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`);
}

/** Fase ativa da campanha (ou null fora do período). `now` injetável para testes. */
export function getActiveCampaignPhase(now = new Date()) {
    const wall = nowInBrasilia(now);
    for (const campaign of CAMPAIGNS) {
        for (const phase of campaign.phases) {
            if (wall >= new Date(phase.start) && wall <= new Date(phase.end)) {
                return { ...phase, campaignId: campaign.id, datesLabel: campaign.dates_label || "" };
            }
        }
    }
    return null;
}

/** Marcos da Black Friday 2026 para o contador regressivo (hora de Brasília). */
export const BF_MILESTONES = {
    antecipacao: { at: "2026-11-27T00:00:00", label: "para o início oficial da Black Friday" },
    "black-friday": { at: "2026-11-29T23:59:59", label: "para o encerramento da campanha" },
};

/** Tempo restante até o marco da fase (null quando esgotado). `now` injetável para testes. */
export function getCampaignTimeLeft(phaseKey, now = new Date()) {
    const milestone = BF_MILESTONES[phaseKey];
    if (!milestone) return null;
    const diff = new Date(milestone.at).getTime() - nowInBrasilia(now).getTime();
    if (diff <= 0) return null;
    const total = Math.floor(diff / 1000);
    return {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
        label: milestone.label,
    };
}

/** Milissegundos até a próxima virada de etapa (null quando não há mais transições). */
export function msUntilNextTransition(now = new Date()) {
    const wall = nowInBrasilia(now);
    const boundaries = [];
    for (const campaign of CAMPAIGNS) {
        for (const phase of campaign.phases) {
            boundaries.push(new Date(phase.start));
            boundaries.push(new Date(new Date(phase.end).getTime() + 1000));
        }
    }
    const future = boundaries.filter((b) => b > wall).sort((a, b) => a - b);
    if (!future.length) return null;
    return future[0].getTime() - wall.getTime() + 500;
}
